import OfficeExtendPlan from './OfficeExtendPlan';

export default OfficeExtendPlan;
